import { useLocation, useParams, useNavigate } from "react-router-dom";
import "./SurveyDetails.css";
import Button from "../../../../Components/Button/Button";
import { useState, useEffect } from "react";
import TaskCompany from "../../../../Components/TaskComany/TaskCompany";
import Head from "../../../../Components/Head/Head";
import SiteDocumentation from "../../../../Components/SurveryDropdown/SurveryDropdown";
import SvgOptions from "../../../../Components/Svg/SvgOptions";
import CreateReportWizard from "../../../../Modals/SiteSurveryReport/CreateReportWizard";
import ViewReportModal from "../../../../Modals/SiteSurveryReport/ViewReportModal";
import SurveyMilestones from "../../../../Components/SurveyMilestone/SurveyMilestone";
import { Get, Put } from "../../../../Services/Server";
import Url from "../../../../Services/Url";
import User from "../../../../Services/User";
import AssignSurveyEngModal from "../../../../Modals/AssignSurveyEngModal/AssignSurveyEngModal";
import { toast } from "react-toastify";
import Utils from "../../../../Services/Utills";

const SurveryDetails = ({ ModalAction }) => {
	const { id } = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const role = User.getRoles();

	const [surveyData, setSurveyData] = useState(null);
	const [companyInfo, setCompanyInfo] = useState(null);
	const [loading, setLoading] = useState(true);
	const [hasReport, setHasReport] = useState(false);

	const isOwner = () => {
		return role.some(
			(r) =>
				r.base === "admin" ||
				r.base === "enterprise-ops" ||
				r.base === "enterprise-bdm"
		);
	};
	console.log(role);
	
	console.log(isOwner());
	const ManageEngineers = () => {
		const options = {
			element: AssignSurveyEngModal,
			title: "Assign Engineer",
			id,
			surveyData,
			closeModal: () => {
				Get(Url.survey.surveyByJobId(id)).then((resp) => {
					setSurveyData(resp[0]);
					ModalAction.closeModal();
				});
			},
		};
		ModalAction.openModal(options);
	};

	const ContinuetoInstallation = () => {
		if (!surveyData?.job_id) return;
		navigate(`../../EnterpriseJobs/Create?jobId=${surveyData.job_id}`);
	};

	const closeJob = () => {
		if (!surveyData) return;

		const updatedSurvey = {
			...surveyData,
			status: "closed",
		};
		Put(Url.survey.updateSurvey(surveyData.id), updatedSurvey)
			.then(() => {
				toast("Job closed");
				setSurveyData(updatedSurvey);
				navigate("../");
			})
			.catch((err) => {
				console.error("Failed to close job", err);
				toast.error("Failed to close job");
			});
	};

	const getDropdownOptions = () => {
		if (!surveyData) return [];

		switch (surveyData.status?.toLowerCase()) {
			case "pending":
				return [{ text: "Assign Engineer", onClick: ManageEngineers }];

			case "ongoing":
				return [
					{ text: "Assign Engineer", onClick: ManageEngineers },
					{ text: "Continue to Installation", onClick: ContinuetoInstallation },
					{ text: "Close Job", onClick: closeJob },
				];

			case "completed":
				return []; // no options

			case "closed":
				return [
					{
						text: "Continue Job",
						onClick: () => {
							const updatedSurvey = { ...surveyData, status: "ongoing" };
							Put(Url.survey.updateSurvey(surveyData.id), updatedSurvey)
								.then(() => {
									toast("Job continued");
									setSurveyData(updatedSurvey);
								})
								.catch((err) => {
									console.error("Failed to continue job", err);
									toast.error("Failed to continue job");
								});
						},
					},
				];

			default:
				return [];
		}
	};

	useEffect(() => {
		const fetchSurveyData = () => {
			setLoading(true);
			Get(Url.survey.surveyByJobId(id))
				.then((response) => {
					const data = response && response[0] ? response[0] : null;

					if (data && Array.isArray(data) && data.length > 5) {
						const [
							survey,
							companyName,
							contactPhone,
							contactEmail,
							contactName,
							companyAddress,
						] = data;
						setSurveyData(survey);
						setCompanyInfo({
							companyName,
							contactPhone,
							contactEmail,
							contactName,
							companyAddress,
						});

						// Check if report exists using the job_id
						checkReportExists(survey.job_id);
					} else {
						console.error(
							"Invalid data structure received for survey details:",
							response
						);
						setSurveyData(null);
						setCompanyInfo(null);
					}
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					setLoading(false);
				});
		};

		if (id) {
			fetchSurveyData();
		}
	}, [id, navigate]);

	const checkReportExists = async (jobNumber) => {
		if (!jobNumber) return;

		try {
			const reportResponse = await Get(Url.survey.getReportByJobId(jobNumber));
			setHasReport(reportResponse && reportResponse !== null);
		} catch (error) {
			console.error("Error checking report existence:", error);
			setHasReport(false);
		}
	};

	const handleCreateReport = () => {
		if (!surveyData || !companyInfo) return;

		const Options = {
			title: hasReport
				? "Edit Site Survey Report"
				: "Create Site Survey Report",
			element: CreateReportWizard,
			closeModal: (resp) => {
				if (resp && resp.success) {
					setHasReport(true);
				}
				ModalAction.closeModal();
			},
			survey: {
				id: surveyData.id,
				jobNumber: surveyData.job_id,
				company: companyInfo.companyName,
				service: "Installation",
				siteType: surveyData.site_type?.typeName || "N/A",
				location: surveyData.site_addr,
				email: companyInfo.contactEmail,
				phoneNumber: companyInfo.contactPhone,
				mainContact: companyInfo.contactName,
				surveyData: surveyData,
			},
			isEdit: hasReport,
		};
		ModalAction.openModal(Options, hasReport ? "Edit Report" : "Create Report");
	};

	const handleViewReport = () => {
		if (!surveyData || !companyInfo) return;

		const Options = {
			title: "Site Survey Report",
			element: ViewReportModal,
			closeModal: () => ModalAction.closeModal(),
			survey: {
				id: surveyData.id,
				jobNumber: surveyData.job_id,
				company: companyInfo.companyName,
				service: "Survey",
				siteType: surveyData?.site_type?.name || "Office",
				location: surveyData.site_addr,
				email: companyInfo?.contactEmail,
				phoneNumber: companyInfo?.contactPhone,
				mainContact: companyInfo?.contactName,
			},
			selected: true,
			logo: "../../Assets/Images/Logo2.png",
		};

		ModalAction.openModal(Options, "View Report");
	};

	if (loading) {
		return (
			<div className="SurveyDetails">
				<></>
			</div>
		);
	}
	if (!surveyData) {
		return (
			<div className="SurveyDetails">
				<p>Survey details not available</p>
			</div>
		);
	}

	return (
		<div>
			<div className="SurveyDetails">
				<div className="SULeft">
					<Head
						title="Survey Details"
						dropdown={isOwner() ? getDropdownOptions() : []}
					></Head>

					<div className="Main">
						<div className="GeneralTaskInfo">
							<div>
								<div>Job ID</div>
								<div>{surveyData.job_id}</div>
							</div>
							<div>
								<div>Company</div>
								<div>
									<TaskCompany>
										{Utils.toPascalCase(companyInfo?.companyName)}
									</TaskCompany>
								</div>
							</div>
							<div>
								<div>Service:</div>
								<div>Survey</div>
							</div>
							<div>
								<div>Site Type:</div>
								<div>
									{Utils.toPascalCase(surveyData.site_type?.typeName) || "N/A"}
								</div>
							</div>
							<div>
								<div>Location:</div>
								<div>{Utils.toPascalCase(surveyData.site_addr) || "N/A"}</div>
							</div>
							<div>
								<div>Email:</div>
								<div>
									{Utils.toPascalCase(companyInfo?.contactEmail) || "N/A"}
								</div>
							</div>
							<div>
								<div>Phone Number:</div>
								<div>{companyInfo?.contactPhone || "N/A"}</div>
							</div>
							<div>
								<div>Main Contact:</div>
								<div>
									{Utils.toPascalCase(companyInfo?.contactName) || "N/A"}
								</div>
							</div>
						</div>
					</div>

					<div className="SurveyDetailsBtns">
						{role.some((r) => r.base === "enterprise") && (
							<div>
								<Button
									icon={SvgOptions.Repair}
									className="Btn-Mid Inverse"
									onClick={handleCreateReport}
								>
									{hasReport ? "Edit Report" : "Create Report"}
								</Button>
							</div>
						)}

						<div>
							<Button
								icon={SvgOptions.Receipt}
								className="Btn-Mid Inverse"
								onClick={handleViewReport}
							>
								View Report
							</Button>
						</div>
					</div>
					<SiteDocumentation surveyData={surveyData} />
				</div>
				<div className="SURight">
					<div>
						<SurveyMilestones hasReport={hasReport} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default SurveryDetails;
